import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ClearingHouse, CollateralBasket, ProductSector, EntityType } from 'api'
import { CollateralBasketsPanelGrid } from './CollateralBasketsPanelGrid'
import { CollateralBasketsPanelGridRow } from './CollateralBasketsPanelGridModel'
import { GridWrapper, rebuildEnabledIds } from '../clearingHouseDialogUtils'
import { clearableCollateralBasketsSelector } from 'selectors/collateralBasketSelectors'
import { createEntityGetterSelector } from 'selectors/entitySelectors'

interface CollateralBasketsPanelProps {
  clearingHouse: ClearingHouse
  clearableCollateralBaskets: CollateralBasket[]
  readOnly: boolean
  getProductSector: (productSectorId: string) => ProductSector | null
  onUpdate: (partialClearingHouse: Partial<ClearingHouse>) => void
}

const mapStateToProps = createStructuredSelector({
  clearableCollateralBaskets: clearableCollateralBasketsSelector,
  getProductSector: createEntityGetterSelector(EntityType.PRODUCT_SECTOR)
})

class CollateralBasketsPanelComponent extends React.Component<CollateralBasketsPanelProps> {
  render() {
    const { readOnly } = this.props

    const rowData = this.buildRowData()

    return (
      <GridWrapper>
        <CollateralBasketsPanelGrid
          rowData={rowData}
          onUpdateDirectClearing={this.handleUpdateDirectClearing}
          onUpdateSponsoredClearing={this.handleUpdateSponsoredClearing}
          disabled={readOnly}
        />
      </GridWrapper>
    )
  }

  private buildRowData(): CollateralBasketsPanelGridRow[] {
    const { clearingHouse, clearableCollateralBaskets, getProductSector } = this.props
    const directClearingLookup = new Set(clearingHouse.permittedDirectBasketIds)
    const sponsoredClearingLookup = new Set(clearingHouse.permittedSponsoredBasketIds)

    return clearableCollateralBaskets.map(collateralBasket => {
      return {
        collateralBasket,
        productSector: getProductSector(collateralBasket.productSectorId),
        directClearingEnabled: directClearingLookup.has(collateralBasket.id),
        sponsoredClearingEnabled: sponsoredClearingLookup.has(collateralBasket.id)
      }
    })
  }

  private handleUpdateDirectClearing = (basketIds: string[], enabled: boolean) => {
    const { clearingHouse, onUpdate } = this.props
    onUpdate({
      permittedDirectBasketIds: rebuildEnabledIds(clearingHouse.permittedDirectBasketIds, basketIds, enabled)
    })
  }

  private handleUpdateSponsoredClearing = (basketIds: string[], enabled: boolean) => {
    const { clearingHouse, onUpdate } = this.props
    onUpdate({
      permittedSponsoredBasketIds: rebuildEnabledIds(clearingHouse.permittedSponsoredBasketIds, basketIds, enabled)
    })
  }
}

export const CollateralBasketsPanel = connect(mapStateToProps)(CollateralBasketsPanelComponent)
